import { render, staticRenderFns } from "./BookCard.vue?vue&type=template&id=4d53c83d"
import script from "./BookCard.vue?vue&type=script&lang=js"
export * from "./BookCard.vue?vue&type=script&lang=js"
import style0 from "./BookCard.vue?vue&type=style&index=0&id=4d53c83d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports